/**
 * Code for blog section
 */
;(function (pyatt, $, window, document, undefined) {

    ///////////////////// Setup ////////////////////////////

    // Document ready
    $(function () {

    });


    ///////////////////// Functions ////////////////////////////


    /**
     * Add span around long part of excerpt
     *
     * @param $excerpt_el
     * @param length
     */
    pyatt.longExcerptMarkup = function ($excerpt_el, length) {
        console.log('excerpt');
        $.each($excerpt_el, function(i, val) {
            console.log(val);
            var words = $(val).text().split(' ');
            var long_part = words.splice(length, 1000);
            words = words.join(' ');
            long_part = long_part.join(' ');

            //replace text
            $(val).html(words).append('<span class="long-part">' + long_part + '</span>');

        });

    };


    /**
     * Change post list link element
     *
     */
    pyatt.modifyPostListLinks = function() {
        //console.log('modifyPostListLinks Start');

        //add anchor wrap to posts in post_list
        var $post_list = $('#post-list'),
            $posts = $post_list.find('.post');

        //disable if not on mobile
        if ($(window).width() > 630) {

            if (!$post_list.hasClass('wrap-linked')) {
                $posts.each(function () {

                    var $tag = $(this).find('.moretag'),
                        $link = $tag.attr('href');

                    //if ( ! $(this).parent().hasClass('wrap-link') ) {
                    $(this).wrap('<a class="wrap-link" href="' + $link + '"></a>');
                    //}
                });

                $post_list.addClass('wrap-linked');
            }

        } else {

            if ($post_list.hasClass('wrap-linked')) {

                $posts.each(function () {

                    if ($(this).parent().hasClass('wrap-link')) {
                        $(this).unwrap();
                    }
                });

                $post_list.removeClass('wrap-linked');

            }
        }
    };


    //// ajax stuff ///


    /**
     * Update post content with ajax request
     *
     * @param post_id
     */
    pyatt.ajaxPost = function(post_id) {
        console.log('ajaxPost Start');

        // set the variables
        var ajaxData = {
            'action': 'pyatt_post_content', // the name of the wp_ajax hook
            'post_id': post_id // the post id from article id
        };

        //update post_list active link (do before ajax make transition seem quicker)
        $('.post').removeClass('active');
        $('#post-' + post_id).addClass('active');
        // make the call
        $.post(ajax_object.ajaxurl, ajaxData, function (response) {
            // do something with our new data

            //replace blog post
            $('#post-box').fadeOut(200, function () {
                $('#post-box').html(response).fadeIn(225, function() {
                    //after new content added...
                });
            });
        });
    };


    /**
     * Update body classes
     *
     * Mainly needed to update archive class for proper layout on mobile
     * (post-box is only hidden on archive class)
     * Only adds generic classes, not category specific ids
     *
     * @param template_type
     */
    pyatt.updateBodyClasses = function(template_type) {

        var $body = $('body');

        if (template_type === 'blog') {
            $body.addClass('blog');
            $body.removeClass('single single-post single-format-standard');
            //remove postid class
            $body.removeClass(function (index, css) {
                return (css.match(/(^|\s)postid-\S+/g) || []).join(' ');
            });
        } else if (template_type === 'archive') {
            $body.addClass('archive category');
            $body.removeClass('single single-post single-format-standard');
            //remove postid class
            $body.removeClass(function (index, css) {
                return (css.match(/(^|\s)postid-\S+/g) || []).join(' ');
            });
        } else if (template_type === 'post') {
            $body.addClass('single single-post single-format-standard');
            $body.removeClass('archive category blog');
        }

    };

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));